import { createActionsGroup } from 'utils/redux-utils'

export default createActionsGroup('USER_INFO')
